export default "__VITE_ASSET__nyD_VqaH__"